import Iconify from "../../../shared/components/Iconify";

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export const ShopLinks = [
   
    {
        title: 'Dashboard',
        path: '/shop-dashboard/savings-account/',
        icon: getIcon('icon-park-solid:laptop'),
    },
    {
        title: 'Transactions Statement',
        path: '/shop-dashboard/savings-account/transactions-statement',
        icon: getIcon('icon-park-solid:transaction'),
    },
    {
        title: 'Charges Statement',
        path: '/shop-dashboard/savings-account/charges',
        icon: getIcon('carbon:cost'),
    },
    {
        title: 'Request for Payment',
        path: '/shop-dashboard/savings-account/invoice',
        icon: getIcon("fa6-solid:hand-holding-dollar"),
    },
    {
        title: 'Send To MNOs / Banks',
        path: '/shop-dashboard/savings-account/transfer-fund',
        icon: getIcon('mdi:bank-transfer-in'),
    },
    {
        title: 'Send money',
        path: '/shop-dashboard/savings-account/send-money',
        icon: getIcon('bi:send-fill'),
    },
    
    {
        title: 'Internal Fund Movement',
        path: '/shop-dashboard/savings-account/internal-fund-movement',
        icon: getIcon('ci:transfer'),
    },
    // {
    //     title: 'Money Order',
    //     path: '/shop-dashboard/money-order-processings/',
    //     icon: getIcon('icon-park-solid:laptop'),
    // },
    // {
    //     title: 'School Payments To Ministry',
    //     path: '/shop-dashboard/savings-account/ministrySchoolPayments/',
    //     icon: getIcon('uil:bill'),
    // },
    // {
    //     title: 'Fund Disbursement',
    //     path: '/shop-dashboard/ktda-payments-processings/',
    //     icon: getIcon('ci:bulb'),
    // },
    // {
    //     title: 'Send To MNOs / Banks',
    //     path: '/shop-dashboard/savings-account/transfer-fund',
    //     icon: getIcon('mdi:bank-transfer-in'),
    // },
    // {
    //     title: 'Send money',
    //     path: '/shop-dashboard/savings-account/send-money',
    //     icon: getIcon('bi:send-fill'),
    // },
    {
        title: 'Bulk Payment',
        path: '/shop-dashboard/savings-account/bulkpayment',
        icon: getIcon('uil:money-withdraw'),
    },
    // {
    //     title: 'Government Services',
    //     path: '/shop-dashboard/savings-account/governmentServices/',
    //     icon: getIcon('map:local-government'),
    // },
    {

        title: 'School Payments',
        path: '/shop-dashboard/savings-account/schoolpayments/schooltable',
        icon: getIcon('uil:bill'),
    },
    // {
    //     title: 'Inua Jamii',
    //     path: '/shop-dashboard/savings-account/inuajamii/',
    //     icon: getIcon('fluent:people-community-28-filled'),
    // },
    {

        title: 'My Operators',
        path: '/shop-dashboard/savings-account/users/operators',
        icon: getIcon('mdi-users'),
    },
    // {
    //     title: 'Auto-Settle Funds',
    //     path: '/shop-dashboard/auto-settlement-card',
    //     icon: getIcon('arcticons:dustsettle'),
    // },
    {

        title: 'Standing Order',
        path: '/shop-dashboard/schedule-settlement',
        icon: getIcon('material-symbols:auto-awesome'),
    },

     {
        title: 'CashBack',
         path: '/shop-dashboard/savings-account/cashback',
         icon: getIcon('mdi-cash-refund'),
     },
    //  {
    //     title: 'EsCrow',
    //      path: '/shop-dashboard/savings-account/escrow',
    //      icon: getIcon('ri:shake-hands-fill'),
    //  },
    //  {
    //     title: 'Split Bills',
    //     path: '/shop-dashboard/savings-account/splitbill',
    //     icon: getIcon("uil:bill"),
    // },

    // {
    //     title: 'API Requests',
    //     path: '/shop-dashboard/savings-account/apis',
    //     icon: getIcon('tabler:api-app'),
    // },

    {
        title: 'My Shop Settings',
        path: '/shop-dashboard/savings-account/account-settings',
        icon: getIcon('ri:shake-hands-fill'),
    },
  
]